import { Shield, ShieldAlert, ShieldCheck, ShieldX } from 'lucide-react'

import { VerifiedCallerIdStatus } from 'src/graphql/types/verifiedCallerIds'
import { cn } from 'src/utils'

export const callerIdStatusLabel = (
  status: VerifiedCallerIdStatus | null | undefined
): string => {
  switch (status) {
    case VerifiedCallerIdStatus.VERIFIED:
      return 'Verified caller ID'
    case VerifiedCallerIdStatus.PENDING:
      return 'Caller ID verification in progress'
    case VerifiedCallerIdStatus.FAILED:
      return 'Caller ID verification failed'
    default:
      return 'Not verified as caller ID'
  }
}

/** The shield glyph for a caller ID status: green verified, yellow pending, red failed, gray none. */
const CallerIdShield = ({
  status,
  size = 16,
  className,
}: {
  status: VerifiedCallerIdStatus | null | undefined
  /** 14 next to xs text, 16 in tables. */
  size?: number
  className?: string
}) => {
  const classes = cn('shrink-0', className)

  switch (status) {
    case VerifiedCallerIdStatus.VERIFIED:
      return (
        <ShieldCheck
          size={size}
          className={cn(classes, 'text-doubleNickel-success-500')}
        />
      )
    case VerifiedCallerIdStatus.PENDING:
      return (
        <ShieldAlert
          size={size}
          className={cn(classes, 'text-doubleNickel-warning-500')}
        />
      )
    case VerifiedCallerIdStatus.FAILED:
      return (
        <ShieldX
          size={size}
          className={cn(classes, 'text-doubleNickel-error-500')}
        />
      )
    default:
      return (
        <Shield
          size={size}
          className={cn(classes, 'text-doubleNickel-gray-400')}
        />
      )
  }
}

export default CallerIdShield
